import { type Provider } from '@angular/core';

import { PORTAL_API_BASE_URL } from './api-base-url.token';

/**
 * Wire the portal surface base URL at app bootstrap:
 *
 *     providePortalApi({ baseUrl: `${environment.apiUrl}/portal` }),
 *
 * `baseUrl` is the full portal-surface root (BFF root + `/portal`); feature
 * services inject `PORTAL_API_BASE_URL` and prepend it to resource paths.
 */
export function providePortalApi(opts: { baseUrl: string }): Provider[] {
  return [{ provide: PORTAL_API_BASE_URL, useValue: opts.baseUrl }];
}
